// extracted by mini-css-extract-plugin
export default {"iconLink":"iconLink__HmHva","disabled":"disabled__Kwgfd","iconCircle":"iconCircle__AR5fT","link":"link__nqDMZ","icon":"icon__rcD0I","inverted":"inverted__r9oY1"};